import { PfContactPointFragment, PfContactPointSystem } from '~/graphql/generated/graphql';

const filterTelecoms = (telecoms: PfContactPointFragment[], system: PfContactPointSystem) => {
  const pfTels = telecoms
    .filter((telecom) => telecom.system === system)
    .sort((tel1, tel2) => tel1.rank - tel2.rank)
    .map((tel) => tel.formattedValue || tel.value);

  return [...new Set(pfTels)];
};

export const getPfTel = (telecoms: PfContactPointFragment[]) => {
  const phones = filterTelecoms(telecoms, 'SYSTEM_PHONE');
  return phones[0] || null;
};

export const getPfEmail = (telecoms: PfContactPointFragment[]) => {
  const emails = filterTelecoms(telecoms, 'SYSTEM_EMAIL');
  return emails[0] || null;
};
